module.exports = require("redux");


/*****************
 ** WEBPACK FOOTER
 ** external "redux"
 ** module id = 31
 ** module chunks = 0
 **/